module.exports = __webpack_public_path__ + "img/wallet.f026f050.svg";